// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_QuerySummary.scss
// module id = 641
// module chunks = 46 88